import { render, staticRenderFns } from "./message-customer-service.vue?vue&type=template&id=0760d937&scoped=true"
import script from "./message-customer-service.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-customer-service.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-customer-service.vue?vue&type=style&index=0&id=0760d937&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0760d937",
  null
  
)

export default component.exports